// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"a971e3c8","845":"7721f6dc"}[chunkId] + ".chunk.js";
};